export default defineNuxtLink({
  componentName: 'AlLink',
  trailingSlash: 'append',
})
